import { render } from "./PopinMail.vue?vue&type=template&id=2acb9004"
import script from "./PopinMail.vue?vue&type=script&lang=js"
export * from "./PopinMail.vue?vue&type=script&lang=js"

import "./PopinMail.vue?vue&type=style&index=0&id=2acb9004&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__